import { breakpoints } from '@/config'

const getBreakpointNameBySize = (currentSize) => {
  const filtered = Object.entries(breakpoints)
    .reverse()
    .filter((i) => currentSize >= i[1])
  return filtered[0][0]
}

const getBreakpoint = () => {
  const size = window.innerWidth
  return {
    size,
    name: getBreakpointNameBySize(size),
  }
}

export default {
  install(Vue) {
    Vue.prototype.$setBreakpointByWindow = () => getBreakpoint()
  },
}
